import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import { array, arrayOf, bool, func, instanceOf, number, object, oneOfType, shape } from "prop-types";
import { action } from "@ember/object";
import { Task, task } from "ember-concurrency";
import { modifier } from "ember-modifier";
import Pagination from "./pagination-dto";

@forbidExtraArgs
export default class Table extends Component {
  @arg(
    arrayOf(
      shape({
        title: stringable.isRequired,
        key: stringable,
      }),
    ),
  )
  headers;

  @arg(oneOfType([array, instanceOf(Task), object])) items;

  @arg(shape({ page: number, total: number, perPage: number.isRequired })) pagination;

  @arg(func) onPageChange;

  @arg(bool) fixed = false;

  @arg(bool) footer = true;

  @arg(bool) outsideBorders = true;

  @arg(bool) paginated = true;

  paginationDto = new Pagination(
    this.pagination?.page || 1,
    this.pagination?.total || this.task?.last?.value?.length,
    this.pagination?.perPage || 10,
  );

  get shouldShowFooter() {
    return this.paginated && (this.footer || this.paginationDto.isPaginated);
  }

  get currentItems() {
    let items = this.task?.last.value;

    return this.paginated ? this.paginationDto?.itemsForPage(items) : items;
  }

  get task() {
    return this.items instanceof Task ? this.items : this.convertToTask;
  }

  convertToTask = task(async () => {
    return this.items;
  });

  updateItems = task(async (task, pagination) => {
    await task.perform();
    this.paginationDto.update(
      pagination?.page || 1,
      pagination?.total || task?.last.value?.length,
      pagination?.perPage,
    );
  });

  handleUpdateOfItems = modifier(() => this.updateItems.perform(this.task, this.pagination));

  @action
  pageChanged(page) {
    if (this.onPageChange) {
      return this.onPageChange(page);
    }

    this.paginationDto.page = page;
  }
}
